import * as React from 'react';
import { SVGProps } from 'react';

const DoubleCheckCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 88 88"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="88" height="88" rx="44" fill="#0EAB6D" />
    <path
      d="M43.3367 46.9333L45.6901 49.2866L59.8001 35.1766L62.1567 37.5333L45.6901 54L35.0834 43.3933L37.4401 41.0366L40.9817 44.5783L43.3367 46.9316V46.9333ZM43.3401 42.22L51.5934 33.965L53.9434 36.315L45.6901 44.57L43.3401 42.22ZM38.6284 51.645L36.2734 54L25.6667 43.3933L28.0234 41.0366L30.3784 43.3916L30.3767 43.3933L38.6284 51.645Z"
      fill="white"
    />
  </svg>
);

export default DoubleCheckCircleIcon;
